

import { useTranslation } from "react-i18next";
import ReactDOM from 'react-dom/client';

import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";

import React, { useState, useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation,
    useNavigate
} from "react-router-dom";

import UserApi from "../../../../services/UserApi.jsx";
import { separatorNumber, useGlobalFunc } from "../../../../global/constants.js";
import { Pagination } from "@mui/material";
import InputTitle from "../../../../compontents/InputTitle.js";






// import homeshadowImg from '../../../assets/homeshadow.png'
// import homescrollImg from '../../../assets/homescroll.png'

// import homepic1Img from '../../../assets/homepic1.png'
// import homepic2Img from '../../../assets/homepic2.png'


const Home = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate()
    const query = new URLSearchParams(location.search);


    const { setLoading, successToast, errorToast } = useGlobalFunc()


    const [data, setData] = useState({})

    const updateData = (i, value) => {
        setData(prevData => ({ ...prevData, [i]: value }));
    };


    async function createNegotiation() {
        setLoading(true)
        try {
            let res = await UserApi.negotiationApply(data)
            console.log(res.data)
            navigate('/membercenter/negotiation')
        }
        catch (errors) {
            errorToast(errors?.response?.data?.message || errors.toString())
        }
        setLoading(false)

    }




    useEffect(() => {

    }, []);




    return <div className="mt-8 text-black96  relative  w-full px-4 sm:px-10 py-5 sm:py-7 bg-white border-solid border border-black06 rounded-[20px]">
        <div className="text-lg font-bold mb-4">新增協談申請單</div>
        <form onSubmit={(e) => { e.preventDefault(); createNegotiation(); }}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-7">
                <div className="sm:col-span-2">
                    <InputTitle title={'被協談者姓名'} required={true} />
                    <input required type="text" value={data.name} onChange={(e) => updateData("name", e.target.value)} className="input w-full" />
                </div>
                <div>
                    <InputTitle title={'聯絡電話'} required={true} />
                    <input required type="text" value={data.phone} onChange={(e) => updateData("phone", e.target.value)} id="dateInput" className="input w-full" />
                </div>

                <div>
                    <InputTitle title={'LINE ID'} required={true} />
                    <input required type="text" value={data.lineId} onChange={(e) => updateData("lineId", e.target.value)} id="dateInput" className="input w-full" />
                </div>

                <div className="">
                    <InputTitle title={'地區'} required={true} />
                    <input required type="text" value={data.region} onChange={(e) => updateData("region", e.target.value)} className="input w-full" />
                </div>

                <div className="">
                    <InputTitle title={'地址'} required={true} />
                    <input required type="text" value={data.address} onChange={(e) => updateData("address", e.target.value)} className="input w-full" />
                </div>

                <div className="sm:col-span-2">
                    <InputTitle title={'協談項目'} required={true} />
                    <input required type="text" value={data.type} onChange={(e) => updateData("type", e.target.value)} className="input w-full" />
                </div>

                <div className="sm:col-span-2">
                    <p className="text-sm font-bold mb-2">說明欄</p>
                    <textarea type="text" value={data.description} onChange={(e) => updateData("description", e.target.value)} className="input w-full h-40" />
                </div>

            </div>

            <div className="flex justify-end mt-4">
                <button type="submit" className="btn1 !min-w-[120px]">
                    送出申請
                </button>
            </div>
        </form>
    </div>

}

export default Home